import React, { useContext } from "react";
import { useEffect } from "react";
import { BasketHistoryDeatils } from "../axios";
import { useState } from "react";
import { toast } from "react-toastify";
import "../assets/css/style.css"

type orderModalProps = {
  basketId: number;
};

const OrderModal: React.FC<orderModalProps> = ({ basketId }) => {
  const [currentData, setCurrentData] = useState([]);

  useEffect(() => {
    const fetchBasketDetails = async () => {
      try {
        const { data } = await BasketHistoryDeatils(basketId);
        setCurrentData(data); // Set the fetched data to the state
      } catch (error) {
        console.log("مشکلی در نمایش جزئیات پیش امده");
        // Handle error as needed
      }
    };

    fetchBasketDetails();
  }, []);

  // console.log("data", currentData);

  return (
    < >
        <tr className="table table-bordered" >
            <th colSpan={2}>عنوان</th>
            <th colSpan={2}>تعداد</th>
        </tr>
        
        {currentData?.filter((item : any) => Number(item.productCategoryID) === 1).map((item : any) => (
            <tr key={item.id} className="table table-bordered border-left">
            <td className="border border-left" colSpan={2}>{item.productTitle}</td>
            <td className="border border-left" colSpan={2}>{item.count}</td>
        </tr>
        ))}
    </>
  );
};

export default OrderModal;
